'use strict';

function defaultValue() {
  var DEFAULT_EMPTY_VALUE = '-';

  function returnStringValue(string) {
    return string.trim().length === 0 ? DEFAULT_EMPTY_VALUE : string;
  }

  return function (value) {
    return !value ? DEFAULT_EMPTY_VALUE : angular.isString(value) ? returnStringValue(value) : value;
  };
}

export default defaultValue;



// WEBPACK FOOTER //
// ./src/app/scripts/helpers/defaultValue.js